module.exports = __webpack_public_path__ + "img/single_pictures_2.c4f5f897.jpg";